<template>
  <div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        landscapeMode
        :columns="grid.columns"
        :merge="grid.merge"
        :gridHeightAuto="true"
        :data="focus.hazardFocusInspItemModelList"
        :columnSetting="false"
        :filtering="false"
        :usePaging="false"
        :editable="editable && !disabled"
        rowKey="focusInspectionItemId"
      >
        <template slot="suffixTitle">
          <font v-if="!focus.hazardFocusInspEquipModelList || focus.hazardFocusInspEquipModelList.length===0" color="#C10015">
            ※ 점검관련대상 탭에서 유해위험기계기구를 추가하세요.
          </font>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames'] && col.name === 'customCol'">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row, colorItems)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <div v-if="editable && col.name === 'customCol' && Boolean(props.row.focusInspectionItemId) && props.row.editFlag !== 'C' && !disabled">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
          <template v-else-if="col.name === 'customCol2' && focus.hazardFocusInspEquipModelList.length > 0 && props.row['checkItemValue'] === 'HIV0000003'">
            <c-tag 
              :editable="editable && !disabled"
              icon="build"
              itemText="machineryName"
              itemValue="check"
              name="hazardFocusInspItemEquipModelList" 
              v-model="props.row.hazardFocusInspItemEquipModelList"
              @addTag="add(props.row)"
              @removeTag="item => remove(item, props.row)"
            />
          </template>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
export default {
  name: 'hazard-focus-inspection-result',
  props: {
    focus: {
      type: Object,
      default: () => ({
        focusInspectionId: '',
        hazardFocusInspItemModelList: [],

        hazardFocusInspEquipModelList: [],
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editable: true,
      detailUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
      grid: {
        merge: [
        ],
        columns: [],
        height: "650px",
        data: [],
      },
      saveCall: {
        saveCallData: '',
      },
      getUrl: '',
      colorItems:[],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });
      // url setting
      // list setting
      this.setHeader();
    },
    setHeader() {
      this.$comm.getComboItems('HHM_ITEM_VALUE_CD').then(_result => {
        this.grid.columns = [
          {
            name: 'checkItemName',
            field: 'checkItemName',
            label: '점검항목',
            align: 'left',
            style: 'width:250px',
            sortable: false,
            fix: true,
          },
          {
            name: 'checkItemValue',
            field: 'checkItemValue',
            label: '결과',
            setHeader: true,
            align: 'center',
            style: 'width:70px',
            type: 'select',
            comboItems: _result,
            sortable: false,
          },
          {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:200px',
                type: 'custom',
                sortable: false
              },
            ]
          },
          {
            name: 'customCol2',
            field: 'customCol2',
            label: '관련기계기구',
            align: 'center',
            style: 'width:200px',
            type: 'custom',
            sortable: false
          },
          {
            name: 'remark',
            field: 'remark',
            label: '비고',
            setHeader: true,
            align: 'left',
            type: 'textarea',
            style: 'width:250px',
            sortable: false,
          },
        ]
      });
    },
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      let requestContents = props.row.checkTypeName +" / " + props.row.checkItemName
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.focusInspectionItemId,
          ibmTaskTypeCd: 'ITT0000085',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.isFull = true;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.focusInspectionItemId,
          ibmTaskTypeCd: 'ITT0000085',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.isFull = true;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
              this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
              this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
            this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
              this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
            this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
              this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

       if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.isFull = true;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.isFull = true;
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.$emit('getDetail')
    },
    datachange(props) {
      props.row.hhmHazardousMachineryIds = '';
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    add(row) {
      this.row = row;
      this.popupOptions.title = '관련 유해위험기계기구 검색'; // 관련 유해위험기계기구 검색
      this.popupOptions.param = {
        type: 'multiple',
        hazardFocusInspEquipModelList: this.focus.hazardFocusInspEquipModelList
      };
      this.popupOptions.target = () => import(`${'./hazardFocusInspectionEquipPop.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (!this.row.hazardFocusInspItemEquipModelList) this.row.hazardFocusInspItemEquipModelList = [];
      if (data.selectData && data.selectData.length > 0) {
        this.$_.forEach(data.selectData, item => {
          if (this.$_.findIndex(this.row.hazardFocusInspItemEquipModelList, { hhmHazardousMachineryId: item.hhmHazardousMachineryId }) === -1) {
            this.row.hazardFocusInspItemEquipModelList.push({
              hhmHazardousMachineryId: item.hhmHazardousMachineryId,
              focusInspectionItemId: this.row.focusInspectionItemId,
              machineryName: item.machineryName,
            })
          }
          if (this.row.editFlag !== 'C') {
            this.row.editFlag = 'U'
          }
        })
      }
    },
    remove(item, row) {
      row.hazardFocusInspItemEquipModelList = this.$_.reject(row.hazardFocusInspItemEquipModelList, {hhmHazardousMachineryId: item.hhmHazardousMachineryId})
      row.editFlag = 'U'
    }
  }
};
</script>
